import { styled, TextField } from "@mui/material";

const StyledInput = styled(TextField)(({ theme }) => ({
  "input[type=number]": {
    MozAppearance: "textfield",
  },
  "input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
}));

export default StyledInput;
